import { ACH, ACH_METHOD, AFFIRM, AFFIRM_METHOD, APPLE_PAY_METHOD, BACS, BACS_METHOD, CARD, CARD_METHOD, GOOGLE_PAY_METHOD, KLARNA, KLARNA_METHOD, PADS, PADS_METHOD, SEPA, SEPA_METHOD } from '../constants/PaymentElement';
export const isCardOrWallet = paymentMethod => {
  return paymentMethod === CARD_METHOD || paymentMethod === GOOGLE_PAY_METHOD || paymentMethod === APPLE_PAY_METHOD;
};
export const isBnpl = paymentMethod => {
  return paymentMethod === KLARNA || paymentMethod === AFFIRM;
};
export const isACHorSEPA = paymentMethod => {
  return paymentMethod === ACH || paymentMethod === SEPA;
};
export const isACHorPADS = paymentMethod => {
  return paymentMethod === ACH || paymentMethod === PADS;
};
export const stripeToHSPaymentMethod = stripePaymentMethod => {
  switch (stripePaymentMethod) {
    case CARD_METHOD:
      return CARD;
    case ACH_METHOD:
      return ACH;
    case BACS_METHOD:
      return BACS;
    case PADS_METHOD:
      return PADS;
    case SEPA_METHOD:
      return SEPA;
    case KLARNA_METHOD:
      return KLARNA;
    case AFFIRM_METHOD:
      return AFFIRM;
    // Apple/Google Pay is considered CARD as well
    default:
      return CARD;
  }
};
export const hsToStripePaymentMethod = paymentMethod => {
  switch (paymentMethod) {
    case CARD:
      return CARD_METHOD;
    case ACH:
      return ACH_METHOD;
    case BACS:
      return BACS_METHOD;
    case PADS:
      return PADS_METHOD;
    case SEPA:
      return SEPA_METHOD;
    case KLARNA:
      return KLARNA_METHOD;
    case AFFIRM:
      return AFFIRM_METHOD;
    // Apple/Google Pay is considered CARD as well
    default:
      return CARD_METHOD;
  }
};